<!--合同管理-->
<template>
  <div class="contractcManage">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>合同管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 合同管理列表 </span>
      </div>
      <div class="fr">
        <el-button type="text" @click="hnadleToHistory" class="fr" id="auto-0"
          ><i class="ic-contract"></i>历史合同</el-button
        >
      </div>
    </div>
    <div class="table-custom-box" id="auto-1">
      <el-table :data="dataList" border>
        <el-table-column
          prop="contractName"
          label="合同名称"
          width="300"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="签署状态" width="150">
          <template v-slot="scope">
            <span v-if="scope.row.signStatus == 1" class="sign-status">未签署</span>
            <span v-if="scope.row.signStatus == 2" class="sign-status sign">已签署</span>
            <span v-if="scope.row.signStatus == 6" class="sign-status sign">签署中</span>
          </template>
        </el-table-column>
        <el-table-column label="签署渠道" width="150">
          <template v-slot="scope">
            <span v-if="scope.row.signChannel == 1">线下</span>
            <span v-if="scope.row.signChannel == 0">线上</span>
          </template>
        </el-table-column>
        <el-table-column prop="secondPartyName" label="承运公司" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="contractNo" label="合同编号" width="300">
          <template v-slot="scope">
            <span v-if="scope.row.contractType == 2"> {{ scope.row.contractNo }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="deadline" label="有效期" width="180">
          <template v-slot="scope">
            <span v-if="scope.row.signTime">
              {{ scope.row.signTime | stamp2TextDate }}-{{ scope.row.expireTime | stamp2TextDate }}</span
            >
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template v-slot="scope">
            <el-button
              type="text"
              v-if="scope.row.signStatus == 1 && scope.row.signChannel == 0"
              class="font-size12"
              @click="handleSign(scope.row)"
              >去签署</el-button
            >
            <el-button type="text" v-if="scope.row.signStatus == 2" class="font-size12" @click="handleToView(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--账期合同-->
    <contract-comp v-if="contractVisible" :contractVisible="contractVisible" @callback="handleContractCallback" />
    <el-dialog :visible.sync="accountContractTip" title="账期支付合同" custom-class="tip-dialog">
      <p>
        - 您有{{ contractNum }}个待签署的账期支付协议，如不及时签署，会影响到发布<span class="font-orange"
          >账期货源</span
        ><br />
        - 默认签署方式为"批量签署"
      </p>
      <div slot="footer">
        <el-button type="primary" @click="handleSignContract">去签署</el-button>
      </div>
    </el-dialog>

    <!--货物运输合同 -->
    <contract-comp
      v-if="freightageVisible"
      :contractVisible="freightageVisible"
      @callback="handleFreightageCallback"
      :contractType="2"
    />
    <el-dialog :visible.sync="freightageContractTip" title="货物运输合同" custom-class="tip-dialog">
      <p>
        - 您有{{ freightTodoCount }}个待签署的货物运输合同<br />
        - 默认签署方式为"批量签署"
      </p>
      <div slot="footer">
        <el-button type="primary" @click="handleSignFreightageContract">去签署</el-button>
      </div>
    </el-dialog>

    <!--油气合同 -->
    <contract-comp
      v-if="fuelData.visible"
      :contractVisible="fuelData.visible"
      @callback="handleFuelCallback"
      :contractType="7"
    />
    <el-dialog :visible.sync="fuelData.contractTip" title="油气合同" custom-class="tip-dialog">
      <p>
        - 您有{{ fuelData.fuelTodoCount }}个待签署的货物运输合同<br />
        - 默认签署方式为"批量签署"
      </p>
      <div slot="footer">
        <el-button type="primary" @click="handleSignFuelContract">去签署</el-button>
      </div>
    </el-dialog>

    <!--短信验证-->
    <el-dialog
      :visible.sync="validPhoneTip"
      title="验证手机号"
      custom-class="tip-dialog"
      :before-close="handleCloseValidPhoneTip"
    >
      <p class="font-f90"><span class="send-tip"></span>因合同内容涉及到敏感信息，查看合同详情需验证手机号</p>
      <div class="send-box">
        <div class="send-item">
          <span class="name">手机号</span>
          <span class="dec">{{ userPhone }}</span>
        </div>
        <div class="send-item">
          <span class="name">验证码</span>
          <div class="send-code-box">
            <el-input
              placeholder="请输入验证码"
              :maxlength="6"
              type="text"
              auto-complete="off"
              v-model.trim="validCode"
            >
            </el-input>
            <el-button @click="getCode" class="code-btn" :disabled="countdown.issend">
              <span v-if="countdown.issend" class="sen-dec">{{ countdown.second }}s</span>
              <span v-else>获取验证码</span>
            </el-button>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="handleSure" :disabled="!validCode">确定</el-button>
      </div>
    </el-dialog>

    <!--安全升级-->
    <el-dialog :visible.sync="authStatus" title="安全升级" custom-class="tip-dialog" :close-on-click-modal="false">
      <p>系统检查到，您尚未设置系统管理员，为了您的账户安全，请及时设置系统管理员。</p>
      <div slot="footer">
        <el-button @click="authStatus = false" round>暂不处理</el-button>
        <el-button type="primary" @click="hanldeToSetManager" round>设置管理员</el-button>
      </div>
    </el-dialog>

    <ul id="contrat-viewer">
      <li v-for="(img, index) in viewerData" :key="index">
        <img :src="img" :alt="img.title || '图片'" style="display: none" />
      </li>
    </ul>

    <!--安全服务管控计划-->
    <el-dialog
      :visible.sync="contractPreviewVisible"
      title="预览合同"
      custom-class="contractc-dia"
      :before-close="handleCloseContractPreview"
    >
      <div class="send-box">
        <iframe :src="htmlUrl" class="contract-protocol-iframe"></iframe>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="handleSureSign">同意并签署</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:1
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/settings.new.api';
import config from '@/assets/js/config';
import ContractComp from '@/components/ContractComp';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
export default {
  name: 'ContractManage',
  components: {
    ContractComp
  },
  data() {
    return {
      dataList: [],
      contractUrl: '',
      contractVisible: false,
      heightObj: {
        height: window.innerHeight - 300 + 'px'
      },
      accountContractTip: false,
      contractNum: 0, // 账期合同待签署数量
      freightTodoCount: 0, // 货物运输合同待签署数量
      freightageVisible: false,
      freightageContractTip: false,
      validPhoneTip: false,
      userPhone: WUYI.currentData.user.usermobile,
      validCode: '',
      contractNo: '',
      timer: null,
      countdown: {
        first: false,
        issend: false,
        second: 60
      },
      authStatus: false,
      fuelData: {
        visible: false, // 签署弹框
        contractTip: false, // 待签收合同数量弹框提示
        fuelTodoCount: 0 // 未签署合同数量
      },
      signChannel: '',
      contratViewer: '',
      viewerData: [],
      itemNow: '',
      htmlUrl: '',
      contractPreviewVisible: false
    };
  },
  created() {
    this.init();
    this.getPromptPromotion();
  },
  methods: {
    getPromptPromotion() {
      axios.post(api.promptPromotion).then(res => {
        if (res.data.promptPromotionFlag) this.authStatus = true;
      });
    },
    init() {
      axios.post(api.getContractList, { queryType: 1 }).then(res => {
        this.dataList = res.data.list;
        this.contractNum = res.data.todoCount;
        this.freightTodoCount = res.data.freightTodoCount;
        this.fuelData.fuelTodoCount = res.data.fuelTodoCount;
      });
    },
    handleSign(item) {
      this.itemNow = item;
      // contractType 1.账期合同 2.货物运输合同
      if (item.contractType == 1) {
        if (this.contractNum > 1) {
          this.accountContractTip = true;
        } else {
          this.contractVisible = true;
        }
      } else if (item.contractType == 2) {
        if (this.freightTodoCount > 1) {
          this.freightageContractTip = true;
        } else {
          this.freightageVisible = true;
        }
      } else if (item.contractType == 7) {
        if (this.fuelData.fuelTodoCount > 1) {
          this.fuelData.contractTip = true;
        } else {
          this.fuelData.visible = true;
        }
      } else if (item.contractType == 13 || item.contractType == 14 || item.contractType == 16) {
        // 货物保障合同
        this.validPhoneTip = true;
      }
    },
    handleToView(item) {
      this.itemNow = item;

      this.signChannel = item.signChannel;
      this.contractNo = item.contractNo;
      this.validPhoneTip = true;
    },
    handleContractCallback(item) {
      this.contractVisible = false;
      if (item.needFreshStatus) {
        this.init();
      }
    },
    handleSignContract() {
      this.accountContractTip = false;
      this.contractVisible = true;
    },
    handleSignFreightageContract() {
      this.freightageContractTip = false;
      this.freightageVisible = true;
    },
    handleFreightageCallback(item) {
      this.freightageVisible = false;
      if (item.needFreshStatus) {
        this.init();
      }
    },
    // 去签署
    handleSignFuelContract() {
      this.fuelData.contractTip = false;
      this.fuelData.visible = true;
    },
    // 合同签署完回调
    handleFuelCallback(item) {
      this.fuelData.visible = false;
      if (item.needFreshStatus) {
        this.init();
      }
    },
    hnadleToHistory() {
      this.$router.push({ path: '/contractHistory' });
    },
    //倒计时
    countDown() {
      var _this = this;
      if (this.countdown.second == 0) {
        this.countdown.issend = false;
        this.countdown.second = 60;
      } else {
        this.countdown.second--;
        this.timer = setTimeout(function () {
          _this.countDown();
        }, 1000);
      }
    },
    getCode() {
      if (this.countdown.issend) return;
      if (
        (this.itemNow.contractType == 13 || this.itemNow.contractType == 14 || this.itemNow.contractType == 16) &&
        this.itemNow.signStatus == 1
      ) {
        axios
          .post(api.sendSmsForOutstandingPay, {
            mobilePhone: this.userPhone
          })
          .then(res => {
            this.countdown.issend = true;
            this.countDown();
          });
      } else {
        axios.post(api.contractSendSms).then(res => {
          this.countdown.issend = true;
          this.countDown();
        });
      }
    },
    handleCloseValidPhoneTip() {
      this.validPhoneTip = false;
      clearTimeout(this.timer);
      this.validCode = '';
      this.countdown.issend = false;
      this.countdown.second = 60;
    },
    handleSure() {
      if (
        (this.itemNow.contractType == 13 || this.itemNow.contractType == 14 || this.itemNow.contractType == 16) &&
        this.itemNow.signStatus == 1
      ) {
        axios
          .post(api.validateSmsForOutstandingPay, {
            mobilePhone: this.userPhone,
            smsNum: this.validCode
          })
          .then(res => {
            this.validPhoneTip = false;
            clearTimeout(this.timer);
            this.countdown.issend = false;
            this.countdown.second = 60;

            axios
              .post(
                api.getOutstandingPayInfo,
                { flowSeqNo: this.itemNow.flowSeqNo, contractType: this.itemNow.contractType },
                { backself: true }
              )
              .then(res => {
                if (res.success && res.data?.contractList && res.data?.contractList.length) {
                  const contract = res.data?.contractList[0];
                  this.htmlUrl = contract.htmlUrl;
                  this.contractPreviewVisible = true;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(res => {
                this.$message.error(res.message);
              });
          });
      } else {
        axios.post(api.contractCheckSms, { authCode: this.validCode, contractNo: this.contractNo }).then(res => {
          this.handleCloseValidPhoneTip();
          if (this.signChannel == 1) {
            this.viewerData = res.data.downLoadUrl.split(',');
            this.$nextTick(() => {
              this.showViewer();
            });
          } else {
            WUYI.openNewtab(res.data.downLoadUrl);
          }
        });
      }
    },
    handleSureSign() {
      // 签署接口
      let options = {
        contractType: this.itemNow.contractType,
        mobilePhone: this.userPhone,
        smsNum: this.validCode,
        flowSeqNo: this.itemNow.flowSeqNo
      };

      axios.post(api.contractSign, options).then(response => {
        this.handleCloseContractPreview();
        setTimeout(() => {
          this.init();
        }, 3000);
      });
    },
    handleCloseContractPreview() {
      this.validCode = '';
      this.contractPreviewVisible = false;
    },
    hanldeToSetManager() {
      this.authStatus = false;
      window.location.href = './settings.html#/updateAdmin';
    },
    showViewer() {
      const dom = document.getElementById('contrat-viewer');
      this.contratViewer = new Viewer(dom);
      this.contratViewer.show();
      dom.addEventListener('hidden', () => {
        this.contratViewer.destroy(); // 关闭时销毁实例
      });
    }
  }
};
</script>
<style scoped>
.contractcManage {
  margin-bottom: 40px;
}
.sign-status {
  display: block;
  width: 58px;
  height: 22px;
  background: #fcf5eb;
  border: 1px solid #f8e5c9;
  color: #e29f4f;
  text-align: center;
}
.sign-status.sign {
  background: #e8f8ef;
  border: 1px solid #bfeed4;
  color: #47c26e;
}
.send-tip {
  display: inline-block;
  margin: -2px 3px 0 3px;
  width: 16px;
  height: 16px;
  background: url('../../assets/img/common/ico_fbhy_qrsj_g.png') no-repeat;
  background-size: 100%;
  vertical-align: middle;
}
.send-box {
  margin: 10px 0 0 5px;
}
.sen-dec {
  color: #58626b;
}
.send-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.send-item .name {
  width: 60px;
  color: #90a0b1;
}
.send-item .dec {
  color: #58626b;
}
.send-code-box {
  width: 288px;
  position: relative;
  overflow: hidden;
}
.send-code-box .code-btn {
  position: absolute;
  top: 1px;
  right: 2px;
  bottom: 4px;
  padding: 10px 5px;
  background: none;
  border: none;
  color: #1cc466;
  height: 30px;
  z-index: 2;
}
</style>
<style>
.contractcManage .privacy-policy-dia {
  width: 860px;
}
.contractcManage .privacy-policy-dia-content {
  margin: 0 10px;
}
.contractcManage .privacy-policy-dia .el-dialog__body {
  padding-top: 10px;
}
.contractcManage .privacy-policy-iframe {
  width: 100%;
  overflow-y: auto;
  border: none;
  margin-bottom: 10px;
}
.contractcManage .contractc-dia {
  width: 857px;
  height: 655px;
}
.contractcManage .ic-contract {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  background: url(../../assets/img/setting/ico_htgl_lsht@2x.png) no-repeat;
  background-size: 16px;
  margin: -2px 2px 0 0;
}
.contractcManage .contract-protocol-iframe {
  width: 100%;
  height: 400px;
  overflow-y: auto;
  border: none;
}
</style>
